import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { Avatar } from "@/components/common";
import { api, apiError } from "@/lib/api";
import { cn } from "@/lib/utils";

export const usePhotoLikes = (paths) => {
  const [likes, setLikes] = useState({});
  const key = (paths || []).join("|");
  useEffect(() => {
    if (!key) return;
    api.post("/photos/likes", { paths: key.split("|").slice(0, 20) }).then(({ data }) => setLikes(data)).catch(() => {});
  }, [key]);
  const toggle = async (path) => {
    try { const { data } = await api.post("/photos/like", { path }); setLikes((l) => ({ ...l, [path]: data })); }
    catch (e) { toast.error(apiError(e)); }
  };
  return { likes, toggle };
};

export const LikeBar = ({ info, onToggle }) => {
  if (!info) return null;
  return (
    <div className="absolute inset-x-0 bottom-0 flex flex-col items-center gap-3 p-5" onClick={(e) => e.stopPropagation()} data-testid="photo-like-bar">
      {info.is_owner ? (
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white" data-testid="photo-like-count">
          <Heart className="h-4 w-4 fill-current text-primary" /> {info.count} {info.count === 1 ? "like" : "likes"}
        </span>
      ) : (
        <button type="button" onClick={onToggle} aria-pressed={info.liked} aria-label={info.liked ? "Unlike photo" : "Like photo"}
          className={cn("inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold backdrop-blur-md transition-[transform,background-color] active:scale-95", info.liked ? "bg-primary text-primary-foreground" : "bg-white/10 text-white hover:bg-white/20")}
          data-testid="photo-like-button">
          <Heart className={cn("h-4 w-4", info.liked && "fill-current")} /> <span data-testid="photo-like-button-count">{info.count}</span>
        </button>
      )}
      {info.is_owner && info.liked_by?.length > 0 && (
        <ul className="flex max-w-[90vw] flex-wrap justify-center gap-2" aria-label="Liked by" data-testid="photo-liked-by">
          <li className="self-center text-xs uppercase tracking-widest text-white/60">Liked by</li>
          {info.liked_by.map((p) => (
            <li key={p.id}><Link to={`/members/${p.id}`} className="flex items-center gap-2 rounded-full bg-white/10 py-1 pl-1 pr-3 text-sm text-white hover:bg-white/20" data-testid={`photo-liker-${p.id}`}>
              <Avatar person={p} size={24} />{p.name}
            </Link></li>
          ))}
        </ul>
      )}
    </div>
  );
};
